/*
 * @Author: hzm
 * @Date: 2022-11-21 13:00:18
 * @Description: 
 */

export default class Base {
  ElMessage: any;
  ElMessageBox: any;
  ElLoading: any;
  ElNotification: any;
  loadingInstance: any;

  constructor(ElMessage, ElMessageBox, ElNotification, ElLoading) {
    this.ElMessage = ElMessage;
    this.ElNotification = ElNotification;
    this.ElMessageBox = ElMessageBox;
    this.ElLoading = ElLoading;
  }
  msg(content) {
    this.ElMessage.info(content);
    console.log(" this.ElMessage: ", this.ElMessage);
  }
  // 错误消息
  msgError(content) {
    this.ElMessage.error(content);
  }
  // 成功消息
  msgSuccess(content) {
    this.ElMessage.success(content);
  }
  // 警告消息
  msgWarning(content) {
    this.ElMessage.warning(content);
  }
  // 弹出提示
  alert(content, title, options) {
    this.ElMessageBox.alert(content, title || "系统提示", options || {});
  }
  // 错误提示
  alertError(content, title) {
    this.ElMessageBox.alert(content, title || "系统提示", { type: "error" });
  }
  // 成功提示
  alertSuccess(content, title) {
    this.ElMessageBox.alert(content, title || "系统提示", { type: "success" });
  }
  // 警告提示
  alertWarning(content, title) {
    this.ElMessageBox.alert(content, title || "系统提示", { type: "warning" });
  }
  // 通知提示
  notify(content) {
    this.ElNotification.info(content);
  }
  // 错误通知
  notifyError(content) {
    this.ElNotification.error(content);
  }
  // 成功通知
  notifySuccess(content) {
    this.ElNotification.success(content);
  }
  // 警告通知
  notifyWarning(content) {
    this.ElNotification.warning(content);
  }
  // 确认窗体
  confirm(content) {
    return this.ElMessageBox.confirm(content, "系统提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    });
  }
  confirmWithOptions(content, options) {
    return this.ElMessageBox.confirm(content, "系统提示", options);
  }
  // 提交内容
  prompt(content) {
    return this.ElMessageBox.prompt(content, "系统提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    });
  }
  promptWithOptions(content, options) {
    return this.ElMessageBox.prompt(content, "系统提示", options);
  }
  // 打开遮罩层
  loading(content) {
    this.loadingInstance = this.ElLoading.service({
      lock: true,
      text: content,
      background: "rgba(0, 0, 0, 0.7)",
    });
  }
  // 关闭遮罩层
  closeLoading() {
    this.loadingInstance.close();
  }
};

